import { render, staticRenderFns } from "./DialogPaymentDetails.vue?vue&type=template&id=8f8bc7ce"
import script from "./DialogPaymentDetails.vue?vue&type=script&lang=js"
export * from "./DialogPaymentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports